<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-none element-with-heading" id="uncategorized">
<div class="heading heading-with-title heading-without-image" id="uncategorized-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Praise For CJ Carver</h1>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">‘A shocking, complex and beautifully written thriller and another cracker from the pen of bestseller CJ Carver’</p>
<p class="alignment-block-content alignment-block-content-left"><b>Reader’s Retreat</b></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">‘CJ Carver can do no wrong. Fabulous. Extremely fabulous. Read this series. It’s the best!’</p>
<p class="alignment-block-content alignment-block-content-left"><b>Northern Crime</b></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">‘A fast and ingenious thriller that pits the brilliantly addictive Forrester and Davies against a tense and chillingly real conspiracy… I’m full of admiration’</p>
<p class="alignment-block-content alignment-block-content-left"><b>Isabelle Grey, author</b></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">‘This is an extraordinarily tense, clever thriller. Don’t expect to sleep, because this is unputdownable’</p>
<p class="alignment-block-content alignment-block-content-left"><b>Frost Magazine</b></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">‘A terrific page-turner. Heart-stopping action and a heroine with guile as well as guts’</p>
<p class="alignment-block-content alignment-block-content-left"><b>Harlen Coben, author</b></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">‘Anyone who is a member of a book club should be recommending (<i>Spare Me the Truth</i>) to their fellow readers with great gusto’</p>
<p class="alignment-block-content alignment-block-content-left"><b>Book Addict Shawn</b></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">‘Carver gives us strong heroines battling against the odds, fast-moving plots and a strong sense of place. She deservedly won the CWA Debut Dagger for <i>Blood Junction</i>’</p>
<p class="alignment-block-content alignment-block-content-left"><b>Publishing News</b></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">“I’m so glad this is the first of a series: I want more… and I want it now!’</p>
<p class="alignment-block-content alignment-block-content-left"><b>Julia Crouch, author</b></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">‘Fast, smart and furious… it will have you clinging on by your fingertips. CJ Carver is one of the best thriller writers working today’</p>
<p class="alignment-block-content alignment-block-content-left"><b>Tom Harper, former CWA Chairman</b></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">‘A complex tale of betrayal and deception. CJ Carver writes with compassion about characters she really cares about’</p>
<p class="alignment-block-content alignment-block-content-left"><b>Parker Bilal, author</b></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">‘A top-notch thriller writer. CJ Carver is one of the best’</p>
<p class="alignment-block-content alignment-block-content-left"><b>Simon Kernick, author</b></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">‘A high-wire act of a thriller, with a plot as ingeniously constructed as a sudoku puzzle’</p>
<p class="alignment-block-content alignment-block-content-left"><b>The Lady Magazine</b></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">‘Powerful writing, a gripping plot and a unique setting… outstanding’</p>
<p class="alignment-block-content alignment-block-content-left"><b>The Mystery and Thriller Club</b></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise-for-cj-carver.vue?2a3dee5b